import { ContaRecorrenteContentDespesa } from "components/Features/Financeiro/ContaRecorrente";
import { useBreadcrumb } from "features/breadcrumbs";

function ContaRecorrenteDespesaPage() {
  useBreadcrumb([
    { name: "Financeiro", url: "/financeiro" },
    { name: "Despesas", url: "/financeiro/despesa" },
    {
      name: "Despesas recorrentes",
      url: "/financeiro/despesa/conta-recorrente",
    },
  ]);

  return (
    <>
      <ContaRecorrenteContentDespesa />
    </>
  );
}

export default ContaRecorrenteDespesaPage;
